import { ReconfigureAgentTypeFormWebComponent } from './component/ReconfigureAgentTypeFormWebComponent';
import { WEB_COMPONENT_RECONFIGURE_AGENT_TYPE_FORM } from '../../../../webcomponents.constants';

export { ReconfigureAgentTypeFormWebComponent };

window.customElements.define(WEB_COMPONENT_RECONFIGURE_AGENT_TYPE_FORM, ReconfigureAgentTypeFormWebComponent);
